module.exports = __webpack_public_path__ + "static/media/2.1.1b1c8def.png";